import { Box, Grid, TextField, Tooltip } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SCUIButton, SCUILoading } from '../../../../atomic/atoms';
import { SCUICustomDataGrid } from '../../../../atomic/molecules';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import Switch from '@mui/material/Switch';
import { CustomerCommand, OperatorCommand } from '../../../../services/command';
import { CustomerQuery } from '../../../../services/query';
import TimeHelper from '../../../../utils/time';
import Swal from 'sweetalert2';
import { SCRP } from './scrPaper.classes';

interface IProps {
    datas?: any;
}
export const ScrPaper: FC<IProps> = ({ datas }) => {
    const { t } = useTranslation();
    const [status, setStatus] = useState(false);
    const [text, setText] = useState('');
    const [refreshStatus, setRefreshStatus] = useState(false);
    const [statusRiskChangeHistroy, setStatusRiskChangeHistory] = useState<any>([]);
    const [source, setSource] = useState<any>(null);
    const [pageSize, setPageSize] = useState(5);
    const [nameList, setNameList] = useState<any>([]);
    const refreshStatusList = () => {
        setRefreshStatus((prevLoading) => !prevLoading);
    };

    const handleChangeSwitch = (event?: any) => {
        setStatus(event.target.checked);
    };
    let array: any[];
    let uniqueSet: Set<any>;
    const columns: ExtendedGridColDef[] = [
        { field: 'date', headerName: t('general.date'), flex: 1 },
        {
            field: 'change',
            headerName: t('customerInformation.change'),
            flex: 1,
            renderCell: (params: any) => {
                // change değerine göre isim bulma
                let find_name = nameList.find(function (obj: any) {
                    return obj.operatorId === params.row.change;
                });
                // source kontrolü
                const isNotBackoffice = params.row.source === 'Otomatik' || params.row.source === 'CRM';
                // Sonuç oluşturma
                const result = isNotBackoffice ? (
                    '-'
                ) : find_name ? (
                    find_name.firstName && find_name.lastName ? (
                        find_name.firstName + ' ' + find_name.lastName
                    ) : (
                        'OperatorId => ' + params.row.change
                    )
                ) : (
                    <Grid sx={{ justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                        <SCUILoading />
                    </Grid>
                );
                return <>{result}</>;
            },
        },
        {
            field: 'source',
            headerName: t('general.tradingPlatform'),
            flex: 1,
            renderCell: (params: any) => {
                return (
                    <div>
                        {params.row.source !== null && (
                            <b
                                style={{
                                    color:
                                        params.row.source === 'Otomatik'
                                            ? 'green'
                                            : params.row.source === 'CRM'
                                              ? 'rgb(110,175,232)'
                                              : params.row.source === 'BO' || params.row.source === 'Backoffice'
                                                ? 'red'
                                                : 'black' /* Varsayılan renk */,
                                }}
                            >
                                {params.row.source}
                            </b>
                        )}
                    </div>
                );
            },
        },
        {
            field: 'description',
            headerName: t('general.description'),
            flex: 1,
            renderCell: (params: any) => {
                return (
                    <div>
                        <Tooltip title={params.row.description}>
                            <p>
                                {params.row.description?.length > 45
                                    ? params.row.description.slice(0, 18) + ' ...'
                                    : params.row.description}
                            </p>
                        </Tooltip>
                    </div>
                );
            },
        },
    ];
    const GetCustomerScrStatus = async () => {
        CustomerQuery.GetCustomerRiskStatusByCustomerId(datas.customer.customerId)
            .then((res: any) => {
                if (res.data.isCusromerRisky !== null) {
                    setStatus(res.data.isCusromerRisky);
                    if (res.data?.source !== null) {
                        setSource(res.data?.source);
                    }
                }
            })
            .catch((error: any) => {
                Swal.fire(t('general.error'), ' ', 'error');
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };
    const İnsertCustomerRiskStatus = async () => {
        let params = {
            CurrentIsCustomerRisky: status,
            CustomerId: datas.customer.customerId,
            StatusChangeReason: text,
        };
        if (source === 'Otomatik' || source === 'Backoffice' || source === 'BO' || source === null) {
            if (text && text.trim().length > 0) {
                CustomerCommand.InsertCustomerRiskStatusChangeHistory(params)
                    .then(() => {
                        Swal.fire(t('general.added'), ' ', 'success');
                        refreshStatusList();
                        setText('');
                    })
                    .finally(() => {});
            } else {
                Swal.fire(t('mobilePanel.noEmpty'), ' ', 'error');
            }
        } else {
            Swal.fire('İşlem platformu Backoffice veya Otomatik olmadığı için işlem yapamazsınız. ', ' ', 'error');
        }
        //:Swal.fire(t('general.emptyFieldControlText'), " ", "error");
    };
    const CustomerRiskStatusChangeHistoryList = async () => {
        let params = {
            customerId: datas.customer.customerId,
        };
        CustomerCommand.CustomerRiskStatusChangeHistoryList(params)
            .then((res: any) => {
                if (res) {
                    let parseData = res.customerRiskStatusChangeHistoryList.map((item: any) => {
                        return {
                            date: TimeHelper.formatDateHour(item.operationDate) || '-',
                            change: item.operatorId || '-',
                            description: item.statusChangeReason || '',
                            source: item?.source,
                        };
                    });
                    setStatusRiskChangeHistory(parseData);
                    array = parseData.map((obje: any) => obje.change);
                    uniqueSet = new Set(array);
                    array = Array.from(uniqueSet);
                    GetUserNameByOperatorId(array);
                }
            })
            .finally(() => {});
    };
    const GetUserNameByOperatorId = async (array: any) => {
        if (array.length > 0) {
            OperatorCommand.GetOperatorsByOperatorId({ operatorIds: array }).then((res: any) => {
                if (res) {
                    let parseData = res.data.map((item: any) => {
                        return {
                            operatorId: item.operatorId,
                            firstName: item.firstName,
                            lastName: item.lastName,
                        };
                    });
                    setNameList(parseData);
                }
            });
        }
    };
    useEffect(() => {
        GetCustomerScrStatus();
        CustomerRiskStatusChangeHistoryList();
    }, [refreshStatus]);
    return (
        <Grid className={SCRP.page} container>
            <Grid
                className={SCRP.controlsColumn}
                sx={{ padding: '8px', marginTop: '2rem' }}
                size={{
                    xl: 4,
                    lg: 4,
                    md: 12,
                    xs: 12,
                }}
            >
                <Grid
                    className={SCRP.switchRow}
                    size={{
                        xl: 12,
                        lg: 12,
                        md: 12,
                        xs: 12,
                    }}
                    sx={{ marginBottom: '8px' }}
                >
                    <Switch
                        className={SCRP.inputSwitchRisk}
                        checked={status}
                        onChange={handleChangeSwitch}
                    />{' '}
                    <b>{t('customerInformation.scrMember')}</b>
                </Grid>
                <Grid
                    sx={{ marginBottom: '8px' }}
                    size={{
                        xl: 12,
                        lg: 12,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <TextField
                        className={SCRP.inputTextareaReason}
                        variant="outlined"
                        multiline
                        rows={6}
                        sx={{ minWidth: '100%' }}
                        placeholder={t('customerInformation.reasonChange')}
                        value={text}
                        onChange={(event: any) => {
                            setText(event.target.value);
                        }}
                    />
                </Grid>
                <Grid
                    className={SCRP.actionsRow}
                    display={'flex'}
                    justifyContent={'flex-end'}
                    size={{
                        xl: 12,
                        lg: 12,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <SCUIButton
                        className={SCRP.inputButtonSend}
                        text={t('general.send')}
                        type="primary"
                        sizeType="default"
                        style={{ height: '32px' }}
                        size="s"
                        onClick={() => {
                            İnsertCustomerRiskStatus();
                            refreshStatusList();
                        }}
                    />
                </Grid>
            </Grid>
            <Grid
                className={SCRP.historyColumn}
                container
                sx={{ padding: '8px' }}
                size={{
                    xl: 8,
                    lg: 8,
                    md: 12,
                    xs: 12,
                }}
            >
                <Grid
                    className={SCRP.datagridWrap}
                    sx={{ marginLeft: '1rem' }}
                    size={{
                        xl: 12,
                        lg: 12,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <Box className={SCRP.datagrid}>
                        <SCUICustomDataGrid
                            rows={statusRiskChangeHistroy}
                            columns={columns}
                            randomId
                            pageSize={pageSize}
                            onPageSizeChange={(i: number) => {
                                setPageSize(i);
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    );
};
